module.exports = __webpack_public_path__ + "img/41e3246.jpg";